export default __webpack_public_path__ + "static/media/Lite-paper.33e8afd7.png";